import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Spinner from '../../components/Spinner';
import './AdminDashboard.css';

function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      if (!token) {
        navigate('/login');
        return;
      }

      const response = await axios.get('/api/admin/stats', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStats(response.data);
      setLoading(false);
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.removeItem('adminToken');
        navigate('/login');
      } else {
        setLoading(false);
      }
    }
  };

  if (loading) return <Spinner text="Loading dashboard..." />;

  return (
    <div className="admin-dashboard">
      <div className="dashboard-header">
        <h1>Dashboard Overview</h1>
        <p>Welcome to your WTF Wear admin dashboard</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card primary">
          <h3>Total Products</h3>
          <div className="stat-value">{stats?.total || 0}</div>
        </div>

        <div className="stat-card success">
          <h3>Published & Visible</h3>
          <div className="stat-value">{stats?.visible_published || 0}</div>
          <div className="stat-label">Showing on site</div>
        </div>

        <div className="stat-card warning">
          <h3>Unpublished</h3>
          <div className="stat-value">{stats?.unpublished || 0}</div>
          <div className="stat-label">Not visible to customers</div>
        </div>

        <div className="stat-card neutral">
          <h3>Hidden</h3>
          <div className="stat-value">{stats?.hidden || 0}</div>
          <div className="stat-label">Catalog visibility = hidden</div>
        </div>

        <div className="stat-card neutral">
          <h3>Featured</h3>
          <div className="stat-value">{stats?.featured || 0}</div>
        </div>

        <div className="stat-card neutral">
          <h3>Categories</h3>
          <div className="stat-value">{stats?.categories || 0}</div>
        </div>

        <div className="stat-card info">
          <h3>Total Orders</h3>
          <div className="stat-value">{stats?.total_orders || 0}</div>
        </div>

        <div className="stat-card warning">
          <h3>Pending Orders</h3>
          <div className="stat-value">{stats?.pending_orders || 0}</div>
        </div>
      </div>

      <div className="admin-info-box">
        <h3>Important Notes</h3>
        <ul>
          <li>Only <strong>Published & Visible</strong> products appear on the storefront</li>
          <li>Products synced from Printify can be edited locally and synced back to Printify</li>
          <li>Enable "Sync changes to Printify" when editing products to update both systems</li>
          <li>Orders are automatically sent to Printify for fulfillment</li>
        </ul>
      </div>
    </div>
  );
}

export default AdminDashboard;
